<template>
  <!--  푸터  -->

  <!-- <div id="section5" class="company_box type05"> -->
  <div id="footer_area">
    <div class="footer">
      <div class="footer_top">
        <div
          class="footer_link"
          @mouseover="cssfooterlink = true"
          @mouseout="cssfooterlink = false"
        >
          <button class="f_link_btn">이용약관</button>
          <ul class="f_link" :class="{ on: cssfooterlink }">
            <li>
              <router-link to="/PersonalPolicy" @click.native="cssfooterlink = false">개인정보 처리방침</router-link>
            </li>
            <li>
              <router-link to="/Email" @click.native="cssfooterlink = false">이메일무단 수집거부</router-link>
            </li>
            <!-- <li><a href="">사이트맵</a></li> -->
            <li>
              <router-link to="/Company/Network" @click.native="cssfooterlink = false">오시는 길</router-link>
            </li>
          </ul>
        </div>
        <div
          class="family_site"
          @mouseover="cssFamilySite = true"
          @mouseout="cssFamilySite = false"
        >
          <button class="family_btn">패밀리사이트</button>
          <ul class="link" :class="{ on: cssFamilySite }">
            <li>
              <a href="https://www.dongkuk.com" target="_blank">동국홀딩스</a>
            </li>
            <li>
              <a href="http://www.dongkuksteel.com" target="_blank">동국제강</a>
            </li>
            <li>
                <a href="http://www.dongkukcm.com" target="_blank">동국씨엠</a>
            </li>
            <li>
              <a href="https://www.intergis.co.kr/kor/Main.do" target="_blank">인터지스</a>
            </li>
            <li>
              <a href="http://www.dongkuksystems.com/" target="_blank">동국시스템즈</a>
            </li>
            <li>
              <a href="http://www.ferrumclub.com/" target="_blank">페럼클럽</a>
            </li>
            <li>
              <a href="https://mp.ferruminfra.co.kr/" target="_blank">MRO (MP)</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer_bottom">
        <router-link to="/">
          <span class="footer_logo"></span>
        </router-link>
        <p class="address">서울시 중구 을지로5길 19(수하동) 페럼타워 (주)페럼인프라</p>
        <p class="copyright">COPYRIGHT© 2019 FERRUM INFRA CO., LTD. ALL RIGHTS RESERVED.</p>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  data: () => ({
    message: "Footer.vue",
    cssFamilySite: false,
    cssfooterlink: false
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue